// Namespace "company": company settings
const company = {
  'nav.adminCompany': 'Company settings',
  'admin.overview.company.title': 'Company settings',
  'admin.overview.company.desc': 'Configure compensatory time off days for the company',
  'company.title': 'Company settings',
  'company.compTime.section': 'Compensatory time off days (CTO)',
  'company.compTime.enabled': 'Enable compensatory time off days',
  'company.compTime.enabledHint': 'Without activation, the company has no compensatory time off days.',
  'company.compTime.maxDays': 'Maximum CTO days per user and calendar year',
  'company.save': 'Save',
  'company.saved': 'Settings saved.',
  'company.error.negative': 'The maximum value must not be negative.',
  'company.error.load': 'Settings could not be loaded.',
  'company.error.save': 'Saving failed.',
};

export default company;
